
import { defineComponent } from 'vue';

import Faq01Image from '@/assets/image/faq/faq01.png';

export default defineComponent({
  name: 'FaqQECIT',
  setup() {
    return {
      Faq01Image,
    };
  },
});
